<h1 mat-dialog-title>
    Edit Folder
</h1>

<mat-dialog-content class="dialog-body">
    <!-- Folder Name Section -->
    <div class="folder-name-section">
        <h4>Folder Name</h4>
        <mat-form-field appearance="outline" class="folder-name-field">
            <input matInput
                   type="text"
                   [(ngModel)]="folder.name"
                   [disabled]="isAllTablesFolder()"
                   placeholder="Enter folder name"
                   required
                   #nameInput>
            <mat-hint *ngIf="isAllTablesFolder()">The "All Tables" folder cannot be renamed</mat-hint>
            <mat-error *ngIf="!folder.name || folder.name.trim() === ''">
                Folder name is required
            </mat-error>
        </mat-form-field>
    </div>

    <!-- Folder Color Section -->
    <div class="folder-color-section">
        <h4>Folder Icon Color</h4>
        <div class="color-radio-group" role="radiogroup" aria-label="Folder Icon Color">
            <div class="color-row">
                <label *ngFor="let color of folderIconColors; let i = index"
                        class="color-radio-label"
                        [class.selected]="folder.iconColor === color.value">
                    <input type="radio"
                        class="color-radio-input"
                        name="folderColor"
                        [value]="color.value"
                        [(ngModel)]="folder.iconColor"
                        (change)="onColorChange(color.value)"
                        [attr.aria-label]="color.name">
                    <div class="color-swatch"
                        [style.background-color]="color.value"
                        [title]="color.name">
                    </div>
                </label>
            </div>
        </div>
    </div>

    <div class="tables-section">
        <h4>Manage tables in this folder</h4>
        <div class="table-list">
            <div *ngFor="let table of tables" class="table-item">
                <span class="table-name">{{getTableName(table)}}</span>
                <button mat-button
                        class="action-button"
                        [class.add-button]="!isTableInFolder(table)"
                        [class.remove-button]="isTableInFolder(table)"
                        (click)="toggleTableInFolder(table)">
                    {{isTableInFolder(table) ? 'Remove' : 'Add'}}
                </button>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-button color="primary" (click)="onSave()">Save</button>
</mat-dialog-actions>